<div class="search" [ngClass]="{ 'search--focus': focusClass }" (focusin)="focusClass = true" (focusout)="focusClass = false">
  <i [class]="icon" [style.color]="iconColor"></i>
  <input class="search__input" [placeholder]="placeholder" (input)="onValueChange(value)" [(ngModel)]="value" />
</div>
